/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./MapperValueSpecChip.vue?vue&type=template&id=4ef3a805&scoped=true"
import script from "./MapperValueSpecChip.vue?vue&type=script&lang=js"
export * from "./MapperValueSpecChip.vue?vue&type=script&lang=js"
import style0 from "./MapperValueSpecChip.vue?vue&type=style&index=0&id=4ef3a805&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ef3a805",
  null
  
)

export default component.exports